import { Component, computed, input } from '@angular/core'
import { MenuItem, MenuItemComponent } from './menu-item.component'

export const menuComponentTestIds = {
  container: 'menu-container',
}

export interface MenuItemGroup {
  key: string
  items: MenuItem[]
}

export type MenuItems = MenuItem[] | MenuItemGroup[]

@Component({
  selector: 'ftr-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
  imports: [MenuItemComponent],
})
export class MenuComponent {
  readonly menuItems = input.required<MenuItems>()
  readonly trackClicks = input<boolean>()
  readonly maxWidth = input<number>(20)

  readonly menuItemGroups = computed<MenuItemGroup[]>(() => {
    const items = this.menuItems()
    return isMenuItemGroup(items) ? items : [{ key: 'items', items }]
  })

  protected readonly testIds = menuComponentTestIds
}

function isMenuItemGroup(items: MenuItems): items is MenuItemGroup[] {
  return items.length > 0 && 'key' in items[0]
}
